const CONFIG = {
  SPECTRUM: [
    'rgb(255,0,0)',
    'rgb(255,113,0)',
    'rgb(0,125,2)',
    'rgb(103,0,154)',
    'rgb(255,0,107)',
    'rgb(128,0,0)',
    'rgb(154,99,36)',
    'rgb(0, 0,117)',
    'rgb(230, 25,75)',
    'rgb(67,99,216)',
    'rgb(0,0,0)',
  ],
};

export default CONFIG;
